// extracted by mini-css-extract-plugin
module.exports = {"btnsContainer":"RecoverTributModal_btnsContainer__gfVq4","recoverBtn":"RecoverTributModal_recoverBtn__1MrLb","textInfo":"RecoverTributModal_textInfo__oLnIZ"};